import React, { useContext } from 'react';
import ThrottlingCheckbox from 'integrations/components/ThrottlingCheckbox';
import AdditionalFields from 'integrations/aws/common/AdditionalFields';
import FormDataContext from 'integrations/contexts/FormDataContext';

import { AdvancedOptionsContext } from './context/AdvancedOptions';
import type { HandleFieldUpdateType, AdvancedOptionsContextType } from './types';

interface Props {
  onChange: HandleFieldUpdateType;
}

const FormAdvancedOptions = ({ onChange }: Props) => {
  const { formData } = useContext(FormDataContext);
  const { isAdvancedOptionsVisible, setAdvancedOptionsVisibility } =
    useContext<AdvancedOptionsContextType>(AdvancedOptionsContext);

  const { defenderThrottleEnabled } = formData;

  const handleToggle: (visible: boolean) => void = (visible) => {
    setAdvancedOptionsVisibility(visible);
  };

  return (
    <AdditionalFields title="Advanced Options" visible={isAdvancedOptionsVisible} onToggle={handleToggle}>
      <ThrottlingCheckbox
        id="defenderThrottleEnabled"
        defaultChecked={defenderThrottleEnabled?.value}
        onChange={onChange}
      />
    </AdditionalFields>
  );
};

export default FormAdvancedOptions;
